import { Card, Divider } from "antd";

import RegisterForm from "./components/RegisterForm";
import { styles } from "./styles/registerStyles";
import logo from "../../assets/images/airp_logo.png";
import dayjs from "../../config/dayjs";

export default function RegisterPage() {
  return (
    <div style={styles.container}>
      <div style={{ width: "100%" }}>
        <div style={styles.logoContainer}>
          <img alt="logo" src={logo} style={styles.logo} />
        </div>
        <Card title="Register" style={styles.registerCard}>
          <RegisterForm />
          <div style={styles.registerText}>
            Already have an account? <a href="/login">Click here</a> to login.
          </div>
          <Divider />
          <div style={styles.copyright}>© AIRP {dayjs().year()}</div>
        </Card>
      </div>
    </div>
  );
}
